import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import FileSaver from 'file-saver';
import { BehaviorSubject, Observable, Subscription, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import * as XLSX from 'xlsx';

import { environment } from '@app/env-service';

@Injectable({
  providedIn: 'root',
})
export class ImporterService {
  excelFileType :string =
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  excelFileExtension :string = '.xlsx';

  private readonly _loading = new BehaviorSubject<boolean>(<boolean>false);
  loading$ = this._loading.asObservable();

  constructor(private http :HttpClient) {}

  getImportSpecs(params ?:{ [param :string] :string | string[] }) :Observable<any> {
    return this.http.get(`${environment.urlV2}/imports/specs`, {
      params,
    });
  }

  getMappingSuggestions(data :FormData) :Observable<any> {
    return this.http.post(`${environment.urlV2}/imports/mapping_suggestions`, data);
  }

  doImport(fd :FormData) :Observable<any> {
    return this.http.post(`${environment.urlV2}/imports`, fd);
  }

  checkJobStatus(jobId :number) :Observable<any> {
    return this.http.get(`${environment.url}/jobs/${jobId}`);
  }

  private saveExcelFile(buffer :any, fileName :string, ext ?:string) :void {
    const data :Blob = new Blob([buffer], { type: this.excelFileType });
    FileSaver.saveAs(data, fileName + (ext ? ext : this.excelFileExtension));
  }

  private downloadAsExcelFile(
    recordSheet :XLSX.WorkSheet,
    filename :string,
    type :string,
  ) :void {
    const wb :XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, recordSheet, 'Records');

    const excelBuffer :any = XLSX.write(wb, {
      bookType: 'xlsx',
      type: 'array',
    });

    this.saveExcelFile(excelBuffer, filename, type);
  }

  exportToExcel(rows :any[] = [], filename :string = 'Import File') :void {
    const excelData :XLSX.WorkSheet = XLSX.utils.json_to_sheet(rows);
    this.downloadAsExcelFile(excelData, filename, this.excelFileExtension);
  }

  setEmailToNotify(email :string = '', jobId :number = 0) :Observable<any> {
    return this.http
      .post(`${environment.urlV2}/imports/email`, {
        email: email,
        jobId: jobId,
      })
      .pipe(
        map((response :any) => {
          return response;
        }),
        catchError((response) => {
          return throwError(response.error);
        }),
      );
  }

  getExportTemplateData(params ?:{
    [param :string] :string | string[];
  }) :Observable<any> {
    return this.http.get(`${environment.urlV2}/imports/export-template`, {
      params,
    });
  }
}
